import { Box, CircularProgress } from '@mui/material';

function DocumentLoading({ height }: { height: number }) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height={height}
      width="100%">
      <CircularProgress color="primary" />
    </Box>
  );
}

export default DocumentLoading;
